export default __webpack_public_path__ + "static/media/icon_food-and-beverage.8bbec9e0.svg";